import {Injectable} from '@angular/core';
import {BaseService} from './base.service';
import {HttpClient} from '@angular/common/http';
import {ResultApi} from '../viewModel/result_api.model';
import {IValidaCpfEmail} from '../interfaces/valida_cpf_email.interface';
import {IAssinatura} from '../interfaces/assinatura.interface';
import {IValidaProposta} from '../interfaces/valida_proposta.interface';

@Injectable({ providedIn: 'root' })
export class AssinaturaService extends BaseService {

    constructor(private httpClient: HttpClient) {
        super(httpClient);
    }

    public async existeCpfEmail(data: IValidaCpfEmail): Promise<ResultApi> {
        let params = '';
        if (data.cpf != null && data.email != null) {
            // params = `?email=${data.email}&cpf=${data.cpf}`;
            return null;
        }
        if (data.cpf != null && data.email == null) {
            // params = `?cpf=${data.cpf}`;
            params = `/cpf/${data.cpf}`;
        }
        if (data.cpf == null && data.email != null) {
            // params = `?email=${data.email}`;
            params = `/email/${data.email}`;
        }
        // const httpOptions = await this.getHttpOptionsSales();
        const httpOptions = {};
        return this.httpClient
            .get<IValidaCpfEmail>(`${this.salesUrl}/assinatura${params}`, httpOptions)
            .toPromise()
            .then((res: any) => {
                if (res) {
                    return new ResultApi().toResult({ status: 200, data: res, error: null });
                }
                return null;
            })
            .catch((err: any) => {
                return err;
            });
    }

    public async salvar(assinatura: IAssinatura): Promise<ResultApi> {
        // const httpOptions = await this.getHttpOptionsSales();
        const httpOptions = {};
        return this.httpClient
            .post<IAssinatura>(`${this.salesUrl}/assinatura`, assinatura, httpOptions)
            .toPromise()
            .then((res: any) => {
                if (res) {
                    return new ResultApi().toResult({status: 200, data: res, error: null});
                }
                return null;
            })
            .catch((err: any) => {
                return err;
            });
    }

    public async validaProposta(idCotacao: string): Promise<ResultApi> {
        // const httpOptions = await this.getHttpOptionsSales();
        const httpOptions = {};
        const url = `${this.salesDataUrl}/sobjects/SBQQ__Quote__c/${idCotacao}?fields=SBQQ__Uncalculated__c`;
        return this.httpClient
            .get<IValidaProposta>(url, httpOptions)
            .toPromise()
            .then((res: any) => {
                if (res) {
                    return new ResultApi().toResult({status: 200, data: res, error: null});
                }
                return null;
            })
            .catch((err: any) => {
                return err;
            });
    }

    public async validaEmail(email: string) {
        const param: IValidaCpfEmail = this.validaCpfEmailVazio();
        param.email = email;
        try {
            return this.existeCpfEmail(param);
        } catch (err) {
            return err;
        }
    }

    public async validaCpf(cpf: string) {
        const param: IValidaCpfEmail = this.validaCpfEmailVazio();
        param.cpf = cpf;
        try {
            return this.existeCpfEmail(param);
        } catch (err) {
            return null;
        }
    }

    public async validaEmailCpf(email: string, cpf: string) {
        const param: IValidaCpfEmail = this.validaCpfEmailVazio();
        param.email = email;
        param.cpf = cpf;
        try {
            return this.existeCpfEmail(param);
        } catch (err) {
            return null;
        }
    }

    private validaCpfEmailVazio = (): IValidaCpfEmail => ({
        Bairro__c: null,
        BillingCity: null,
        BillingPostalCode: null,
        BillingState: null,
        BillingStreet: null,
        Celular__c: null,
        Data_de_Nascimento__c: null,
        Email__c: null,
        Id: null,
        Id_Vindi__c: null,
        Name: null,
        Numero_Local__c: null,
        Numero_do_Documento_1__c: null,
        Numero_do_Documento_2__c: null,
        Tipo_do_Documento__c: null,
        Type: null,
        attributes: null,
        id: null,
        idCelular__c: null,
        cpf: null,
        email: null
    })

}
